module.exports = __webpack_public_path__ + "static/media/tick.251fc800.svg";